import Navbar from "../../components/Global/Navbar/Navbar";
import { useNavigate } from "react-router-dom";
import innobooster from "../../assets/brands/Innoboosterimage.png";
import backBtn from "../../assets/icons/back-btn.png";
import innovationslogo from "../../assets/brands/innovationsfonden-logo-dk-teal-rgb.png";

export default function InnovationsFonden() {
  const navigate = useNavigate();

  return (
    <div>
      <Navbar />
      <section className="bg-doctio-beige d-icon-full md:h-[calc(100vh-9rem)] pb-28 md:py-16">
        <div className="grid container mx-auto lg:grid-cols-3">
          <div className="col-span-2">
            <button
              className="flex items-center mb-8"
              onClick={() => navigate(-1)}
            >
              <img src={backBtn} width={26} className="mr-3" alt="Tilbage" />
              <p className="text-doctio-green">Tilbage</p>
            </button>

            <h1 className="text-doctio-green mb-10 font-bold text-dxl md:text-d4xl">
              Doctio er støttet af Innovationsfonden
            </h1>

            <p className="md:w-9/12">
              Udviklingen fra FraseDoktor til Doctios webapplikation version 2.0
              med standard tekstfraser og journalkoncepter samt oprettelse af
              egen tekstfraser er støttet af Innovationsfonden.
            </p>

            <a className="font-bold" href="https://innovationsfonden.dk/da">
              Klik her for at gå til Innovationsfondens hjemmeside
            </a>
          </div>

          <div className="col-span-2 md:col-span-1 mt-12 md:mt-0">
            <img
              src={innobooster}
              alt="Innovationsfonden"
              className="mx-auto md:ml-auto picture-shadow w-10/12 md:w-full"
            />
          </div>
        </div>

        <div className="logo-container flex justify-center mt-28 ">
          <img
            src={innovationslogo}
            className="w-5/6 md:w-4/12 opacity-30"
            alt="Innovationsfonden"
          />
        </div>
      </section>
    </div>
  );
}
